import { Box, IconButton, ITheme, TextField, Tooltip, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import { Utilities } from '../../utility/utils';

interface IApiKeyItemProps {
    keyValue: { key: string, validity: Date };
}

const ApiKeyItem: React.FC<IApiKeyItemProps> = ({ keyValue }) => {
    const theme = useTheme() as ITheme;
    const [copied, setCopied] = useState<boolean>(false);

    const onCopy = () => {
        Utilities.copyToClipboard(keyValue.key);
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 1500);
    }
    return (
        <Box display={"flex"} alignItems={"center"} gap={"10px"}>
            <Typography style={{ backgroundColor: theme.palette.primary.main, padding: "8px 12px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "space-between", width:"450px" }}>
                {keyValue.key}
                <Tooltip title="Copy to clipboard">
                    <IconButton onClick={onCopy} size='small'>
                        {copied ? <CheckIcon fontSize='small' /> : <ContentCopyIcon fontSize='small' />}
                    </IconButton>
                </Tooltip>
            </Typography>

            <Typography fontStyle={"italic"}>Expires on {keyValue.validity.toLocaleDateString()}</Typography>
        </Box>
    )
}

export default ApiKeyItem